import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { authAPI, getConfig, searchAPI } from "../../apis";
import ButtonPrimary from "../../components/button/ButtonPrimary";
import InputPassword from "../../components/input/InputPassword";
import InputText from "../../components/input/InputText";
import {
  emailValidation,
  notEmptyValidation,
  validateUserPassword,
} from "../../functions/validation";
import { loginUser } from "../../redux/features/authSlice";
import {
  setMicrosoftUser,
  setsidebarData,
} from "../../redux/features/dataSlice";
// import GoogleIcon from "@mui/icons-material/Google";
import MicrosoftLogin from "react-microsoft-login";
import GoogleImg from "../../media/images/google_icon.svg";
import OfficeImg from "../../media/images/microsoft-logo.png";

import Button from "@mui/material/Button";

import {
  GoogleOAuthProvider,
  useGoogleLogin,
  GoogleLogin,
} from "@react-oauth/google";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { PublicClientApplication } from "@azure/msal-browser";
import { loginRequest, msalConfig } from "../../msal";
import { useMsal } from "@azure/msal-react";
import { useSelector } from "react-redux";
import { wordpressURL } from "../../config";
import { logEvent } from "../../functions/amplitude";
import CleverImg from "../../media/images/clever_icon.svg";
import ClassLinkImg from "../../media/images/ClassLink.svg";

const LoginForm = (props) => {
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const location = useLocation();
  const params = useParams();

  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [loading, setloading] = useState(false);

  const { instance, accounts, inProgress } = useMsal();
  const { microsoftUser } = useSelector((state) => state.data);

  const handleCustomMicrosoft = () => {
    dispatch(setMicrosoftUser(true));
    instance.loginPopup(loginRequest).catch((e) => {
      console.log(e);
    });
  };

  const handleExternalMicrosoftLogin = async (token, provider) => {
    try {
      setloading(true);
      const res = await axios.post(`${authAPI.microsoftLogin}`, {
        accessToken: token,
        provider: provider,
      });
      localStorage.setItem("user", JSON.stringify(res.data));
      setSidebar(res.data);

      dispatch(loginUser({ user: res.data }));
      localStorage.setItem("email", res.data.email);
      dispatch(setMicrosoftUser(true));

      setloading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const setSidebar = async (data) => {
    try {
      const sidebar = await axios.post(
        searchAPI.sidebar,
        {
          callingUserId: data.userId,
          userId: data.userId,
          includeDeletedRecords: 0,
        },
        {
          headers: {
            Authorization: `Bearer ${data.token}`,
          },
        }
      );

      dispatch(setsidebarData(sidebar.data));
    } catch (e) {
      console.log(e);
    }
  };

  async function onSubmitLogin(e) {
    e.preventDefault();

    try {
      setloading(true);
      const res = await axios.post(authAPI.login, {
        emailOrUserName: email,
        password,
      });

      localStorage.setItem("user", JSON.stringify(res.data));
      setSidebar(res.data);

      dispatch(loginUser({ user: res.data }));
      localStorage.setItem("email", res.data.email);

      setloading(false);
    } catch (error) {
      console.log(error.response);
      if (error.response.data.message) {
        toast.error(error.response.data.message);
        setloading(false);
        return;
      }
      toast.error(error.response.data);

      setloading(false);
    }
  }

  const login = useGoogleLogin({
    onSuccess: async (respose) => {
      handleExternalLogin(respose.access_token, "Google");
    },
  });

  const handleExternalLogin = async (token, provider) => {
    try {
      setloading(true);
      const res = await axios.post(`${authAPI.googleLogin}`, {
        token: token,
        provider: provider,
      });
      localStorage.setItem("user", JSON.stringify(res.data));
      setSidebar(res.data);

      dispatch(loginUser({ user: res.data }));
      localStorage.setItem("email", res.data.email);

      setloading(false);
    } catch (e) {
      console.log(e);
    }
  };

  const redirectToCleverOAuth = () => {
    const clientId = process.env.REACT_APP_API_PROD_CLEVER_CLIENTID;
    const redirectUri = encodeURIComponent(
      "https://app.sooth.fyi/signin/clever"
    );
    const cleverAuthUrl = `https://clever.com/oauth/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}`;
    window.location.href = cleverAuthUrl;
  };

  const redirectToClasslinkOAuth = () => {
    const clientId = process.env.REACT_APP_API_PROD_CLASSLINK_CLIENTID;
    const redirectUri = encodeURIComponent(
      "https://app.sooth.fyi/signin/classlink"
    );
    const classLinkUrl = `https://launchpad.classlink.com/oauth2/v2/auth?scope=profile&redirect_uri=${redirectUri}&client_id=${clientId}&response_type=code`;
    window.location.href = classLinkUrl;
  };

  const handleCleverLogin = async (provider) => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");

    if (code && location.includes(provider)) {
      try {
        setloading(true);
        const res = await axios.post(
          `${authAPI.cleverLogin}?code=${code}&provider=${provider}`
        );
        localStorage.setItem("user", JSON.stringify(res.data));
        setSidebar(res.data);

        dispatch(loginUser({ user: res.data }));
        localStorage.setItem("email", res.data.email);

        setloading(false);
      } catch (error) {
        console.error("Error sending the code to backend:", error);
        toast.error("There was an issue logging in with Clever.");
      }
    }
  };

  const handleClasslinkLogin = async (provider) => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get("code");

    if (code && location.includes(provider)) {
      try {
        setloading(true);
        const res = await axios.post(
          `${authAPI.classlinkLogin}?code=${code}&provider=${provider}`
        );
        localStorage.setItem("user", JSON.stringify(res.data));
        setSidebar(res.data);

        dispatch(loginUser({ user: res.data }));
        localStorage.setItem("email", res.data.email);

        setloading(false);
      } catch (error) {
        console.error("Error sending the code to backend:", error);
        toast.error("There was an issue logging in with ClassLink.");
      }
    }
  };

  useEffect(() => {
    if (inProgress === "none") {
      instance
        .handleRedirectPromise()
        .then((response) => {
          if (response) {
            // Assuming the response contains the accessToken property.
            // const accessToken = response.accessToken;
            console.log("Access token:", response);
            // Now you can use the access token to call a protected API or perform other actions.
          }
        })
        .catch((error) => {
          // Handle or log error
          console.error(error);
        });
    }
  });

  const handleClick = (event, href, term) => {
    event.preventDefault();
    logEvent(`click_footer_${term}`, { [term]: "clicked" });
    window.open(href, "_blank", "noopener noreferrer");
  };

  const Terms1 = () => {
    return (
      <p className="terms terms-placement">
        By signing in to Sooth.fyi, you agree to our{" "}
        <a
          href={`${wordpressURL}/terms-of-use/`}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/terms-of-use/`, "terms");
          }}
        >
          Terms of Use
        </a>{" "}
        and{" "}
        <a
          href={`${wordpressURL}/privacy/`}
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/privacy/`, "privacy");
          }}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        .
      </p>
    );
  };

  const Terms2 = () => {
    return (
      <p className="terms">
        By clicking Continue, you agree to Sooth’s{" "}
        <a
          href={`${wordpressURL}/terms-of-use/`}
          target="_blank"
          rel="noreferrer"
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/terms-of-use/`, "terms");
          }}
        >
          Terms of Use
        </a>{" "}
        and{" "}
        <a
          href={`${wordpressURL}/privacy/`}
          onClick={(e) => {
            handleClick(e, `${wordpressURL}/privacy/`, "privacy");
          }}
          target="_blank"
          rel="noreferrer"
        >
          Privacy Policy
        </a>
        .
      </p>
    );
  };

  useEffect(() => {
    const handleResponse = (response) => {
      console.log(accounts);

      if (accounts.length > 0 && microsoftUser) {
        const account = accounts[0];
        const request = {
          scopes: ["user.read"],
          account: account,
        };
        instance
          .acquireTokenSilent(request)
          .then((accessTokenResponse) => {
            handleExternalMicrosoftLogin(
              accessTokenResponse.accessToken,
              "Microsoft"
            );
          })
          .catch((error) => {
            if (
              error.name === "InteractionRequiredAuthError" ||
              error.message.includes("interaction required")
            ) {
              instance.acquireTokenRedirect(request);
            } else {
              console.error(error);
            }
          });
      }
    };
    handleResponse();

    instance.handleRedirectPromise(() => {});
  }, [instance, accounts]);

  useEffect(() => {
    const handleAuthResponse = async () => {
      console.log("Has Code");
      const authResponse = await instance.handleRedirectPromise();
      if (authResponse) {
        const accessToken = authResponse.accessToken;
        console.log(accessToken);
      }
    };

    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const code = params.get("code");
    const error = params.get("error");
    if (error === "access_denied") {
      window.location.href = "/signin";
    }
    // ... now you can use 'code' and 'state' as needed
    if (code) {
      handleAuthResponse();
    }
    console.log(code);

    // Typically, you would then exchange the code for tokens using your server
  }, []);

  useEffect(() => {
    instance
      .handleRedirectPromise()
      .then((response) => {
        if (response) {
          console.log(response);
        } else {
          // No user is logged in
        }
      })
      .catch((error) => {
        // Handle error
        console.error(error);
      });
  }, []);

  useEffect(() => {
    handleCleverLogin("clever");
    handleClasslinkLogin("classlink");
  }, [location.search]);

  return (
    <form onSubmit={onSubmitLogin}>
      <div className="top-box-signin">
        <h1>Sign In</h1>
        {/* <h2>Use Single Sign On</h2> */}
        <p className="center terms">Use your preferred service to sign in</p>
        <div className="signinIcons">
          <div className="icon-col" onClick={login}>
            <img alt="sign in with account" src={GoogleImg} />
            <h5>Google</h5>
          </div>

          <div className="icon-col" onClick={handleCustomMicrosoft}>
            <img alt="sign in with account" src={OfficeImg} />
            <h5>Microsoft</h5>
          </div>
          <div className="icon-col" onClick={redirectToCleverOAuth}>
            <img
              alt="sign in with account"
              src={CleverImg}
              className="integrationLogo"
            />
            <h5>Clever</h5>
          </div>
          <div className="icon-col" onClick={redirectToClasslinkOAuth}>
            <img
              alt="sign in with account"
              src={ClassLinkImg}
              className="integrationLogo"
            />
            <h5>ClassLink</h5>
          </div>
        </div>

        <Terms1 />
        <div className="flex" style={{ marginBottom: "10px" }}>
          <div className="divider divider-or-left"></div>
          <div className="or-text">or</div>
          {/* Divider at the Right End of "or" */}
          <div className="divider divider-or-right"></div>
        </div>

        {/* <h2>Provide your credentials</h2> */}
      </div>
      <div className="credentials">
        <InputText
          placeholder="Email address or username"
          value={email}
          onChange={(e) => setemail(e.target.value)}
        />
        <InputPassword
          placeholder="Password"
          value={password}
          onChange={(e) => setpassword(e.target.value)}
          validationOff
        />

        <ButtonPrimary text="Continue" loading={loading} />
        <ButtonPrimary
          text="Back to Home"
          onClick={() =>
            (window.location.href = process.env.REACT_APP_PRODUCTION_POLICY_URL)
          }
        />
        <p
          className="fp mt-2 mb-2"
          onClick={() => navigate("/forgot-password")}
        >
          Forgot Password
        </p>
        <Terms2 />
      </div>
    </form>
  );
};

export default LoginForm;
